import React, {

    useEffect,

    useState

}

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";

import {

    functions

}

from "../../../constants/common-functions";









//========================================================
// Document Basket Item
//========================================================

export default function DocumentBasketItem({

    item,

    index,

    placementCount = 0,

    mergeSelected = false,

    onToggleMergeSelection

})

{

    //========================================================
    // Content Type
    //========================================================

    const sourceImage =

        item?.basketContentType ===
        "IMAGE_SECTION";



    const derivedImage =

        item?.basketContentType ===
        "DERIVED_IMAGE";



    const image =

        sourceImage ||

        derivedImage;



    const text =

        item?.basketContentType ===
        "TEXT_SECTION";









    //========================================================
    // Placement
    //========================================================

    const placed =

        placementCount > 0;









    //========================================================
    // Image
    //========================================================

    const [imageUrl, setImageUrl] =

        useState(null);



    const [imageLoading, setImageLoading] =

        useState(false);



    const [imageError, setImageError] =

        useState(false);



    const [imagePreviewVisible, setImagePreviewVisible] =

        useState(false);









    //========================================================
    // Drag Start
    //
    // Only the permanent basket ID is transferred.
    //
    // The target cell resolves the actual basket item from
    // shared Document Builder state.
    //========================================================

    const handleDragStart = (event) =>

    {

        event.dataTransfer.effectAllowed =

            "copy";



        event.dataTransfer.setData(

            "application/x-omniscan-basket-item",

            item.basketId

        );



        //====================================================
        // Plain Text Fallback
        //====================================================

        event.dataTransfer.setData(

            "text/plain",

            item.basketId

        );

    };









    //========================================================
    // Toggle Merge Selection
    //========================================================

    const handleToggleMergeSelection = (event) =>

    {

        event.preventDefault();

        event.stopPropagation();



        if (

            !image ||

            !onToggleMergeSelection

        )

        {

            return;

        }



        onToggleMergeSelection(

            item.basketId

        );

    };









    //========================================================
    // Merge Selection Mouse Down
    //
    // Prevent the image-composition control from initiating
    // the basket card's drag operation.
    //========================================================

    const handleMergeMouseDown = (event) =>

    {

        event.stopPropagation();

    };









    //========================================================
    // Image Available
    //
    // Original source images are loaded from their persisted
    // document snippet section.
    //
    // Derived images already contain the PNG Blob generated
    // by the Image Composer.
    //========================================================

    const imageAvailable =

        sourceImage

            ?

            item?.documentSnippetSectionId != null

            :

            derivedImage

                ?

                item?.blob != null

                :

                false;









    //========================================================
    // Load Image
    //
    // SOURCE IMAGE
    //
    //     Retrieved from the authenticated section-image API.
    //
    // DERIVED IMAGE
    //
    //     Loaded directly from the Blob created by Nigel's
    //     Image Mangle.
    //
    // In both cases a temporary browser object URL is created
    // for the thumbnail and modal preview.
    //========================================================

    useEffect(

        () =>

        {

            //================================================
            // Not An Image
            //================================================

            if (

                !image

            )

            {

                setImageUrl(

                    null

                );

                setImageLoading(

                    false

                );

                setImageError(

                    false

                );

                return;

            }



            //================================================
            // Lifecycle
            //================================================

            let cancelled =

                false;



            let objectUrl =

                null;



            //================================================
            // Reset
            //================================================

            setImageUrl(

                null

            );

            setImageLoading(

                true

            );

            setImageError(

                false

            );



            //================================================
            // Derived Image
            //================================================

            if (

                derivedImage

            )

            {

                if (

                    !item?.blob

                )

                {

                    setImageLoading(

                        false

                    );

                    setImageError(

                        true

                    );



                    return;

                }



                try

                {

                    objectUrl =

                        window.URL.createObjectURL(

                            item.blob

                        );



                    setImageUrl(

                        objectUrl

                    );



                    setImageLoading(

                        false

                    );

                }

                catch (

                    error

                )

                {

                    console.error(

                        "Unable to create derived image URL.",

                        error

                    );



                    setImageLoading(

                        false

                    );

                    setImageError(

                        true

                    );

                }



                //============================================
                // Cleanup Derived Image
                //============================================

                return () =>

                {

                    cancelled =

                        true;



                    if (

                        objectUrl

                    )

                    {

                        window.URL.revokeObjectURL(

                            objectUrl

                        );

                    }

                };

            }



            //================================================
            // Source Image Not Available
            //================================================

            if (

                !imageAvailable

            )

            {

                setImageLoading(

                    false

                );

                setImageError(

                    true

                );



                return;

            }



            //================================================
            // Source Image URL
            //================================================

            const url =

                "/resolutionsoftwareplatform/snippet-sniffer/sections/" +

                item.documentSnippetSectionId +

                "/image";



            //================================================
            // Load Source Image
            //================================================

            functions.getBlobFromAjax(

                url,

                function(blob)

                {

                    if (

                        cancelled

                    )

                    {

                        return;

                    }



                    if (

                        !blob

                    )

                    {

                        setImageLoading(

                            false

                        );

                        setImageError(

                            true

                        );



                        return;

                    }



                    //========================================
                    // Create Browser URL
                    //========================================

                    objectUrl =

                        window.URL.createObjectURL(

                            blob

                        );



                    //========================================
                    // Store Image
                    //========================================

                    setImageUrl(

                        objectUrl

                    );



                    setImageLoading(

                        false

                    );

                }

            );



            //================================================
            // Cleanup Source Image
            //================================================

            return () =>

            {

                cancelled =

                    true;



                if (

                    objectUrl

                )

                {

                    window.URL.revokeObjectURL(

                        objectUrl

                    );

                }

            };

        },

        [

            image,

            sourceImage,

            derivedImage,

            imageAvailable,

            item?.documentSnippetSectionId,

            item?.blob

        ]

    );









    //========================================================
    // Open Image Preview
    //========================================================

    const openImagePreview = (event) =>

    {

        event.stopPropagation();



        if (

            !imageUrl

        )

        {

            return;

        }



        setImagePreviewVisible(

            true

        );

    };









    //========================================================
    // Close Image Preview
    //========================================================

    const closeImagePreview = (event) =>

    {

        if (

            event

        )

        {

            event.stopPropagation();

        }



        setImagePreviewVisible(

            false

        );

    };









    //========================================================
    // Image Mouse Down
    //========================================================

    const handleImageMouseDown = (event) =>

    {

        event.stopPropagation();

    };









    //========================================================
    // Image Label
    //========================================================

    const imageLabel =

        derivedImage

            ?

            "COMPOSED IMAGE"

            :

            "IMAGE";









    //========================================================
    // Document / Source Title
    //========================================================

    const sourceTitle =

        derivedImage

            ?

            item?.documentTitle ||

            "Merged Image"

            :

            item?.documentTitle ||

            "Untitled Document";









    //========================================================
    // Source Metadata
    //========================================================

    const derivedSourceCount =

        Array.isArray(

            item?.sources

        )

            ?

            item.sources.length

            :

            0;









    //========================================================
    // Render
    //========================================================

    return (

        <>

            <div

                style={

                    {

                        ...styles.item,

                        ...(placed

                            ?

                            styles.itemPlaced

                            :

                            {}),

                        ...(mergeSelected

                            ?

                            styles.itemMergeSelected

                            :

                            {}),

                        ...(derivedImage

                            ?

                            styles.itemDerived

                            :

                            {})

                    }

                }

                draggable={true}

                onDragStart={

                    handleDragStart

                }

            >

                {/*============================================
                    Drag Rail
                ============================================*/}

                <div style={styles.dragRail}>

                    <div style={styles.dragDots}>

                        ⋮⋮

                    </div>

                </div>









                {/*============================================
                    Body
                ============================================*/}

                <div style={styles.body}>



                    {/*========================================
                        Type / Placement
                    ========================================*/}

                    <div style={styles.typeRow}>

                        <div style={styles.typeAndPlacement}>

                            <div style={styles.type}>

                                {

                                    image

                                        ?

                                        imageLabel

                                        :

                                        text

                                            ?

                                            "TEXT"

                                            :

                                            item?.basketContentType ||

                                            "CONTENT"

                                }

                            </div>



                            {

                                derivedImage &&

                                (

                                    <div style={styles.derivedBadge}>

                                        NIGEL

                                    </div>

                                )

                            }



                            {

                                placed &&

                                (

                                    <div style={styles.placedBadge}>

                                        <span style={styles.placedTick}>

                                            ✓

                                        </span>

                                        <span>

                                            PLACED

                                            {

                                                placementCount > 1

                                                    ?

                                                    " ×" +
                                                    placementCount

                                                    :

                                                    ""

                                            }

                                        </span>

                                    </div>

                                )

                            }

                        </div>



                        <div style={styles.itemNumber}>

                            {

                                String(

                                    index + 1

                                ).padStart(

                                    2,

                                    "0"

                                )

                            }

                        </div>

                    </div>









                    {/*========================================
                        Text Preview
                    ========================================*/}

                    {

                        text &&

                        (

                            <div style={styles.textPreview}>

                                {

                                    item?.selectedText ||

                                    "Text content"

                                }

                            </div>

                        )

                    }









                    {/*========================================
                        Image Preview
                    ========================================*/}

                    {

                        image &&

                        (

                            <div

                                style={

                                    {

                                        ...styles.imagePreview,

                                        ...(imageUrl

                                            ?

                                            styles.imagePreviewClickable

                                            :

                                            {})

                                    }

                                }

                                onClick={

                                    openImagePreview

                                }

                                onMouseDown={

                                    handleImageMouseDown

                                }

                                draggable={false}

                            >

                                {

                                    imageLoading

                                        ?

                                        (

                                            <div style={styles.imageStatus}>

                                                <div style={styles.imageIcon}>

                                                    ▧

                                                </div>



                                                <div>

                                                    <div style={styles.imageTitle}>

                                                        Loading Image

                                                    </div>

                                                    <div style={styles.imageMeta}>

                                                        {

                                                            derivedImage

                                                                ?

                                                                "Preparing composed image..."

                                                                :

                                                                "Retrieving source image..."

                                                        }

                                                    </div>

                                                </div>

                                            </div>

                                        )

                                        :

                                        imageUrl

                                            ?

                                            (

                                                <>

                                                    <img

                                                        src={

                                                            imageUrl

                                                        }

                                                        alt={

                                                            derivedImage

                                                                ?

                                                                "Merged"

                                                                :

                                                                "Source"

                                                        }

                                                        style={styles.thumbnail}

                                                        draggable={false}

                                                    />



                                                    <div style={styles.imageOverlay}>

                                                        View Image

                                                    </div>

                                                </>

                                            )

                                            :

                                            (

                                                <div style={styles.imageStatus}>

                                                    <div style={styles.imageIcon}>

                                                        ▧

                                                    </div>



                                                    <div>

                                                        <div style={styles.imageTitle}>

                                                            {

                                                                derivedImage

                                                                    ?

                                                                    "Composed Image"

                                                                    :

                                                                    "Source Image"

                                                            }

                                                        </div>



                                                        <div style={styles.imageMeta}>

                                                            {

                                                                imageError

                                                                    ?

                                                                    "Unable to load image"

                                                                    :

                                                                    imageAvailable

                                                                        ?

                                                                        "Image available"

                                                                        :

                                                                        "Image unavailable"

                                                            }

                                                        </div>

                                                    </div>

                                                </div>

                                            )

                                }

                            </div>

                        )

                    }









                    {/*========================================
                        Image Merge Selection
                    ========================================*/}

                    {

                        image &&

                        (

                            <div

                                style={

                                    {

                                        ...styles.mergeSelection,

                                        ...(mergeSelected

                                            ?

                                            styles.mergeSelectionSelected

                                            :

                                            {})

                                    }

                                }

                                onClick={

                                    handleToggleMergeSelection

                                }

                                onMouseDown={

                                    handleMergeMouseDown

                                }

                            >

                                <div

                                    style={

                                        {

                                            ...styles.mergeCheckbox,

                                            ...(mergeSelected

                                                ?

                                                styles.mergeCheckboxSelected

                                                :

                                                {})

                                        }

                                    }

                                >

                                    {

                                        mergeSelected

                                            ?

                                            "✓"

                                            :

                                            ""

                                    }

                                </div>



                                <div style={styles.mergeLabel}>

                                    COMBINE

                                </div>

                            </div>

                        )

                    }









                    {/*========================================
                        Source
                    ========================================*/}

                    <div style={styles.source}>

                        <div style={styles.documentTitle}>

                            {

                                sourceTitle

                            }

                        </div>



                        {

                            derivedImage

                                ?

                                (

                                    <div style={styles.sourceMeta}>

                                        {

                                            derivedSourceCount

                                        } source {

                                            derivedSourceCount === 1

                                                ?

                                                "image"

                                                :

                                                "images"

                                        }



                                        <span style={styles.separator}>

                                            ·

                                        </span>



                                        {

                                            formatLayoutMode(

                                                item?.layoutMode

                                            )

                                        }

                                    </div>

                                )

                                :

                                (

                                    <div style={styles.sourceMeta}>

                                        {

                                            item?.pageNumber != null

                                                ?

                                                "Page " +
                                                item.pageNumber

                                                :

                                                "Source page"

                                        }



                                        {

                                            item?.sectionSequence != null &&

                                            (

                                                <>

                                                    <span style={styles.separator}>

                                                        ·

                                                    </span>

                                                    Section {

                                                        item.sectionSequence

                                                    }

                                                </>

                                            )

                                        }

                                    </div>

                                )

                        }

                    </div>

                </div>

            </div>









            {/*============================================
                Image Preview Modal
            ============================================*/}

            {

                imagePreviewVisible &&

                imageUrl &&

                (

                    <div

                        style={styles.modalBackdrop}

                        onClick={

                            closeImagePreview

                        }

                        onMouseDown={

                            handleImageMouseDown

                        }

                    >

                        <div

                            style={styles.modal}

                            onClick={

                                event =>

                                {

                                    event.stopPropagation();

                                }

                            }

                        >

                            {/*================================
                                Modal Header
                            =================================*/}

                            <div style={styles.modalHeader}>

                                <div>

                                    <div style={styles.modalEyebrow}>

                                        {

                                            derivedImage

                                                ?

                                                "COMPOSED IMAGE"

                                                :

                                                "SOURCE IMAGE"

                                        }

                                    </div>



                                    <div style={styles.modalTitle}>

                                        {

                                            sourceTitle

                                        }

                                    </div>

                                </div>



                                <button

                                    type="button"

                                    style={styles.modalClose}

                                    onClick={

                                        closeImagePreview

                                    }

                                >

                                    ×

                                </button>

                            </div>









                            {/*================================
                                Modal Image
                            =================================*/}

                            <div style={styles.modalImageContainer}>

                                <img

                                    src={

                                        imageUrl

                                    }

                                    alt={

                                        derivedImage

                                            ?

                                            "Merged"

                                            :

                                            "Source"

                                    }

                                    style={styles.modalImage}

                                    draggable={false}

                                />

                            </div>









                            {/*================================
                                Modal Footer
                            =================================*/}

                            <div style={styles.modalFooter}>

                                {

                                    derivedImage

                                        ?

                                        (

                                            <>

                                                <span>

                                                    {

                                                        derivedSourceCount

                                                    } source {

                                                        derivedSourceCount === 1

                                                            ?

                                                            "image"

                                                            :

                                                            "images"

                                                    }

                                                </span>



                                                <span style={styles.modalSeparator}>

                                                    ·

                                                </span>



                                                <span>

                                                    {

                                                        formatLayoutMode(

                                                            item?.layoutMode

                                                        )

                                                    }

                                                </span>

                                            </>

                                        )

                                        :

                                        (

                                            <>

                                                <span>

                                                    {

                                                        item?.pageNumber != null

                                                            ?

                                                            "Page " +
                                                            item.pageNumber

                                                            :

                                                            "Source page"

                                                    }

                                                </span>



                                                {

                                                    item?.sectionSequence != null &&

                                                    (

                                                        <>

                                                            <span style={styles.modalSeparator}>

                                                                ·

                                                            </span>

                                                            <span>

                                                                Section {

                                                                    item.sectionSequence

                                                                }

                                                            </span>

                                                        </>

                                                    )

                                                }

                                            </>

                                        )

                                }

                            </div>

                        </div>

                    </div>

                )

            }

        </>

    );

}









//========================================================
// Format Layout Mode
//========================================================

function formatLayoutMode(

    layoutMode

)

{

    switch (

        layoutMode

    )

    {

        case "SOURCE":

            return "Source Layout";


        case "HORIZONTAL":

            return "Horizontal";


        case "VERTICAL":

            return "Vertical";


        case "GRID":

            return "Grid";


        default:

            return "Composed";

    }

}









//========================================================
// Styles
//========================================================

const styles =

{

    item:

    {

        width:

            "100%",

        minHeight:

            120,

        marginBottom:

            12,

        display:

            "flex",

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(255,255,255,0.08)",

        borderRadius:

            6,

        background:

            "rgba(255,255,255,0.055)",

        boxShadow:

            "0 5px 16px rgba(0,0,0,0.10)",

        overflow:

            "hidden",

        cursor:

            "grab",

        transition:

            "border-color 160ms ease, background 160ms ease, box-shadow 160ms ease"

    },

    itemPlaced:

    {

        border:

            "1px solid rgba(32,175,232,0.22)",

        background:

            "rgba(32,175,232,0.045)",

        boxShadow:

            "0 5px 16px rgba(0,0,0,0.10), inset 0 0 0 1px rgba(32,175,232,0.025)"

    },

    itemMergeSelected:

    {

        border:

            "1px solid rgba(32,175,232,0.50)",

        background:

            "rgba(32,175,232,0.075)",

        boxShadow:

            "0 5px 18px rgba(0,0,0,0.12), inset 0 0 0 1px rgba(32,175,232,0.07)"

    },

    itemDerived:

    {

        border:

            "1px solid rgba(32,175,232,0.28)"

    },





    //========================================================
    // Drag Rail
    //========================================================

    dragRail:

    {

        width:

            32,

        minWidth:

            32,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        background:

            "rgba(0,0,0,0.10)",

        borderRight:

            "1px solid rgba(255,255,255,0.05)"

    },

    dragDots:

    {

        color:

            "rgba(255,255,255,0.28)",

        fontSize:

            15,

        fontWeight:

            700,

        letterSpacing:

            -3

    },





    //========================================================
    // Body
    //========================================================

    body:

    {

        flex:

            1,

        minWidth:

            0,

        padding:

            "13px 14px",

        boxSizing:

            "border-box"

    },





    //========================================================
    // Type / Placement
    //========================================================

    typeRow:

    {

        marginBottom:

            9,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        gap:

            8

    },

    typeAndPlacement:

    {

        minWidth:

            0,

        display:

            "flex",

        alignItems:

            "center",

        gap:

            8

    },

    type:

    {

        color:

            OMNISCAN_BLUE,

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.1

    },

    derivedBadge:

    {

        height:

            18,

        padding:

            "0 6px",

        display:

            "inline-flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(255,255,255,0.11)",

        borderRadius:

            9,

        background:

            "rgba(255,255,255,0.055)",

        color:

            "rgba(255,255,255,0.46)",

        fontSize:

            7,

        fontWeight:

            700,

        letterSpacing:

            0.6

    },

    placedBadge:

    {

        height:

            18,

        padding:

            "0 6px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            4,

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(32,175,232,0.22)",

        borderRadius:

            9,

        background:

            "rgba(32,175,232,0.08)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            7,

        fontWeight:

            700,

        letterSpacing:

            0.6,

        whiteSpace:

            "nowrap"

    },

    placedTick:

    {

        fontSize:

            8,

        fontWeight:

            700

    },

    itemNumber:

    {

        color:

            "rgba(255,255,255,0.24)",

        fontSize:

            8,

        fontWeight:

            700

    },





    //========================================================
    // Text Preview
    //========================================================

    textPreview:

    {

        marginBottom:

            12,

        display:

            "-webkit-box",

        WebkitBoxOrient:

            "vertical",

        WebkitLineClamp:

            4,

        overflow:

            "hidden",

        color:

            "rgba(255,255,255,0.76)",

        fontSize:

            11,

        lineHeight:

            1.55

    },





    //========================================================
    // Image Preview
    //========================================================

    imagePreview:

    {

        position:

            "relative",

        height:

            110,

        marginBottom:

            10,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(255,255,255,0.06)",

        borderRadius:

            5,

        background:

            "rgba(0,0,0,0.16)",

        overflow:

            "hidden"

    },

    imagePreviewClickable:

    {

        cursor:

            "zoom-in"

    },

    imageStatus:

    {

        width:

            "100%",

        padding:

            "0 12px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            12,

        boxSizing:

            "border-box"

    },

    thumbnail:

    {

        width:

            "100%",

        height:

            "100%",

        display:

            "block",

        objectFit:

            "contain"

    },

    imageOverlay:

    {

        position:

            "absolute",

        right:

            7,

        bottom:

            7,

        padding:

            "4px 7px",

        borderRadius:

            4,

        background:

            "rgba(8,20,29,0.78)",

        border:

            "1px solid rgba(255,255,255,0.10)",

        color:

            "rgba(255,255,255,0.78)",

        fontSize:

            8,

        fontWeight:

            600,

        pointerEvents:

            "none"

    },

    imageIcon:

    {

        width:

            38,

        height:

            38,

        minWidth:

            38,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        borderRadius:

            4,

        background:

            "rgba(32,175,232,0.09)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            19

    },

    imageTitle:

    {

        marginBottom:

            3,

        color:

            "rgba(255,255,255,0.72)",

        fontSize:

            10,

        fontWeight:

            600

    },

    imageMeta:

    {

        color:

            "rgba(255,255,255,0.30)",

        fontSize:

            8

    },





    //========================================================
    // Merge Selection
    //========================================================

    mergeSelection:

    {

        height:

            28,

        marginBottom:

            10,

        padding:

            "0 8px",

        display:

            "inline-flex",

        alignItems:

            "center",

        gap:

            7,

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(255,255,255,0.08)",

        borderRadius:

            4,

        background:

            "rgba(255,255,255,0.035)",

        cursor:

            "pointer",

        userSelect:

            "none",

        transition:

            "border-color 140ms ease, background 140ms ease"

    },

    mergeSelectionSelected:

    {

        border:

            "1px solid rgba(32,175,232,0.38)",

        background:

            "rgba(32,175,232,0.10)"

    },

    mergeCheckbox:

    {

        width:

            14,

        height:

            14,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        border:

            "1px solid rgba(255,255,255,0.25)",

        borderRadius:

            3,

        background:

            "rgba(0,0,0,0.10)",

        color:

            "#ffffff",

        fontSize:

            9,

        fontWeight:

            700

    },

    mergeCheckboxSelected:

    {

        border:

            "1px solid " +
            OMNISCAN_BLUE,

        background:

            OMNISCAN_BLUE

    },

    mergeLabel:

    {

        color:

            "rgba(255,255,255,0.50)",

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            0.8

    },





    //========================================================
    // Source
    //========================================================

    source:

    {

        paddingTop:

            10,

        borderTop:

            "1px solid rgba(255,255,255,0.06)"

    },

    documentTitle:

    {

        marginBottom:

            4,

        overflow:

            "hidden",

        textOverflow:

            "ellipsis",

        whiteSpace:

            "nowrap",

        color:

            "rgba(255,255,255,0.52)",

        fontSize:

            9,

        fontWeight:

            600

    },

    sourceMeta:

    {

        color:

            "rgba(255,255,255,0.28)",

        fontSize:

            8

    },

    separator:

    {

        margin:

            "0 5px",

        color:

            "rgba(255,255,255,0.16)"

    },





    //========================================================
    // Image Modal
    //========================================================

    modalBackdrop:

    {

        position:

            "fixed",

        top:

            0,

        right:

            0,

        bottom:

            0,

        left:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        padding:

            40,

        boxSizing:

            "border-box",

        background:

            "rgba(5,14,21,0.78)",

        backdropFilter:

            "blur(3px)",

        zIndex:

            5000,

        cursor:

            "default"

    },

    modal:

    {

        width:

            "min(1000px, 90vw)",

        maxHeight:

            "90vh",

        display:

            "flex",

        flexDirection:

            "column",

        background:

            "#10202c",

        border:

            "1px solid rgba(255,255,255,0.10)",

        borderRadius:

            8,

        boxShadow:

            "0 25px 80px rgba(0,0,0,0.42)",

        overflow:

            "hidden"

    },

    modalHeader:

    {

        minHeight:

            66,

        padding:

            "0 20px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        boxSizing:

            "border-box",

        borderBottom:

            "1px solid rgba(255,255,255,0.07)"

    },

    modalEyebrow:

    {

        marginBottom:

            4,

        color:

            OMNISCAN_BLUE,

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.2

    },

    modalTitle:

    {

        maxWidth:

            "70vw",

        overflow:

            "hidden",

        textOverflow:

            "ellipsis",

        whiteSpace:

            "nowrap",

        color:

            "#ffffff",

        fontSize:

            14,

        fontWeight:

            600

    },

    modalClose:

    {

        width:

            34,

        height:

            34,

        padding:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px solid rgba(255,255,255,0.10)",

        borderRadius:

            5,

        background:

            "rgba(255,255,255,0.05)",

        color:

            "rgba(255,255,255,0.72)",

        fontSize:

            22,

        fontWeight:

            300,

        cursor:

            "pointer"

    },

    modalImageContainer:

    {

        flex:

            1,

        minHeight:

            0,

        padding:

            20,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        background:

            "#09141c",

        overflow:

            "auto"

    },

    modalImage:

    {

        display:

            "block",

        maxWidth:

            "100%",

        maxHeight:

            "calc(90vh - 150px)",

        objectFit:

            "contain"

    },

    modalFooter:

    {

        height:

            44,

        minHeight:

            44,

        padding:

            "0 20px",

        display:

            "flex",

        alignItems:

            "center",

        boxSizing:

            "border-box",

        borderTop:

            "1px solid rgba(255,255,255,0.07)",

        color:

            "rgba(255,255,255,0.38)",

        fontSize:

            9

    },

    modalSeparator:

    {

        margin:

            "0 7px",

        color:

            "rgba(255,255,255,0.18)"

    }

};